<script setup>
import { BuildingStorefrontIcon } from '@heroicons/vue/24/outline'
import { useI18n } from '../../i18n.js'

const { locale, t } = useI18n()

defineProps({ pumps: { type: Array, default: () => [] } })

function decimal(value, digits = 2) {
  return value == null ? '—' : new Intl.NumberFormat(locale.value, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(value)
}

function stateLabel(state) {
  if (state === 'filling') return t('pts2UiFilling')
  if (state === 'error') return t('pts2UiError')
  return t('pts2UiIdle')
}
</script>

<template>
  <div v-if="pumps.length" class="pts2-pump-grid">
    <article v-for="pump in pumps" :key="pump.id" class="pts2-pump-card" :class="`is-${pump.state}`">
      <header>
        <span class="pts2-number-badge">{{ pump.id }}</span>
        <BuildingStorefrontIcon aria-hidden="true" />
        <span class="pts2-pump-title">
          <strong>№{{ pump.id }}</strong>
          <small>{{ pump.fuelGradeName || t('pts2UiFuelUnknown') }}</small>
        </span>
        <span class="pts2-state-pill" :class="pump.state">{{ stateLabel(pump.state) }}</span>
      </header>
      <dl class="pts2-pump-values">
        <div><dt>{{ t('pts2UiCurrentVolume') }}:</dt><dd>{{ decimal(pump.volume) }}<template v-if="pump.volume != null"> {{ t('pts2UiLiters') }}</template></dd></div>
      </dl>
      <progress :class="{ inactive: pump.state !== 'filling' }" :value="pump.progressPercent ?? undefined" max="100"
        :aria-label="pump.progressPercent == null
          ? t('pts2UiPumpProgressUnknown', { id: pump.id })
          : t('pts2UiPumpProgress', { id: pump.id, percent: pump.progressPercent })">
        {{ pump.progressPercent == null ? t('pts2UiNoData') : `${pump.progressPercent}%` }}
      </progress>
      <dl class="pts2-pump-values">
        <div><dt>{{ t('pts2UiCurrentAmount') }}:</dt><dd>{{ decimal(pump.amount) }}<template v-if="pump.amount != null"> ₴</template></dd></div>
        <div><dt>{{ t('pts2UiPricePerLiter') }}:</dt><dd>{{ decimal(pump.price) }}<template v-if="pump.price != null"> ₴</template></dd></div>
      </dl>
    </article>
  </div>
  <p v-else class="pts2-inline-empty">{{ t('pts2UiNoPumps') }}</p>
</template>
